import { initPromise } from './i18n/i18n'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { initializeFont } from './lib/fontLoader'
import './index.css'

// Initialize Google Tag Manager
if (import.meta.env.VITE_GTM_ID) {
  const gtmId = import.meta.env.VITE_GTM_ID
  const script = document.createElement('script')
  script.innerHTML =
    `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':` +
    `new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],` +
    `j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=` +
    `'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);` +
    `})(window,document,'script','dataLayer','${gtmId}');`
  document.head.appendChild(script)
}

// Lock screen orientation to portrait on mobile (when supported)
if ('orientation' in screen && 'lock' in (screen.orientation as any)) {
  (screen.orientation as any).lock('portrait').catch(() => {
    // Orientation lock not supported or not allowed - CSS fallback handles this
  })
}

// Initialize Sentry
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment:
      import.meta.env.VITE_SENTRY_ENVIRONMENT ||
      import.meta.env.MODE ||
      'development',
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, _hint) {
      // Filter sensitive data
      if (event.request?.headers) {
        delete event.request.headers.Authorization
      }
      return event
    },
  })
}

const root = ReactDOM.createRoot(document.getElementById('root')!)

// Bootstrap function that always renders the app
async function bootstrap() {
  // Wait for i18n to initialize
  await initPromise

  // Initialize font (loads saved preference from localStorage)
  // Don't block render if font loading fails
  try {
    await initializeFont()
  } catch (error) {
    console.error('Font initialization failed, continuing with default font:', error)
  }

  // Always render the app
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  )
}

bootstrap()
